export const kbbWorks = {
  movie: [
    {
      id: 10,
      title: '하나코리아',
      year: '2026',
      image: require('./movie/hana-korea.webp')
    },
    {
      id: 11,
      title: '검은 수녀들',
      year: '2025',
      image: require('./movie/dark-nuns.webp')
    },
    {
      id: 12,
      title: '행복의 나라',
      year: '2024',
      image: require('./movie/land-of-happiness.webp')
    },
    {
      id: 1,
      title: '기적',
      year: '2021',
      image: require('./movie/1. 기적.jpg')
    },
    {
      id: 2,
      title: '정직한 후보',
      year: '2020',
      image: require('./movie/2. 정직한 후보.jpg')
    },
    {
      id: 3,
      title: '해치지 않아',
      year: '2020',
      image: require('./movie/3. 해치지 않아.jpg')
    },
    {
      id: 4,
      title: '7년의 밤',
      year: '2018',
      image: require('./movie/4. 7년의 밤.jpg')
    },
    {
      id: 5,
      title: '가려진 시간',
      year: '2016',
      image: require('./movie/5. 가려진 시간.jpg')
    },
    {
      id: 6,
      title: '범죄의 여왕',
      year: '2016',
      image: require('./movie/6. 범죄의 여왕.jpg')
    },
    {
      id: 7,
      title: '카트',
      year: '2014',
      image: require('./movie/7. 카트.jpg')
    },
    {
      id: 8,
      title: '광해, 왕이 된 남자',
      year: '2012',
      image: require('./movie/8. 광해, 왕이 된 남자.jpg')
    },
    {
      id: 9,
      title: '번지점프를 하다',
      year: '2001',
      image: require('./movie/9. 번지점프를 하다.jpg')
    },
  ],
  drama: [
    {
      id: 11,
      title: '멋진 신세계',
      year: '2026',
      image: require('./drama/brave-new-world.webp')
    },
    {
      id: 12,
      title: '원경',
      year: '2025',
      image: require('./drama/won-gyeong.webp')
    },
    {
      id: 13,
      title: '독수리 5형제를 부탁해!',
      year: '2025',
      image: require('./drama/for-eagle-brothers.webp')
    },
    {
      id: 14,
      title: '탁류',
      year: '2025',
      image: require('./drama/the-murky-stream.webp')
    },
    {
      id: 1,
      title: '감사합니다',
      year: '2024',
      image: require('./drama/1. 감사합니다.png')
    },
    {
      id: 2,
      title: '커넥션',
      year: '2024',
      image: require('./drama/2. 커넥션.jpg')
    },
    {
      id: 4,
      title: '피라미드 게임',
      year: '2024',
      image: require('./drama/4. 피라미드 게임.jpg')
    },
    {
      id: 3,
      title: '무인도의 디바',
      year: '2023',
      image: require('./drama/3. 무인도의 디바.jpg')
    },
    {
      id: 5,
      title: '더 글로리',
      year: '2022',
      image: require('./drama/5. 더 글로리.jpg')
    },
    {
      id: 6,
      title: '슈룹',
      year: '2022',
      image: require('./drama/6. 슈룹.jpg')
    },
    {
      id: 7,
      title: '꽃피면 달 생각하고',
      year: '2021',
      image: require('./drama/7. 꽃피면 달 생각하고.jpg')
    },
    {
      id: 8,
      title: '슬기로운 의사생활',
      year: '2020',
      image: require('./drama/8. 슬기로운 의사생활.jpeg')
    },
    {
      id: 9,
      title: '아스달 연대기',
      year: '2019',
      image: require('./drama/9. 아스달 연대기.jpg')
    },
    {
      id: 10,
      title: '나의 아저씨',
      year: '2018',
      image: require('./drama/10. 나의 아저씨.jpg')
    },
  ],
}
